export default function Home({ setCurrentPage }) {
  const stats = [["50,000+","Loans Disbursed"],["KSh 50K","Max Loan Amount"],["24 hrs","Disbursement Time"],["15%","Processing Fee Only"]];
  const steps = [["01","Apply Online","Fill out our simple form. No account needed."],["02","Get Reviewed","Our team reviews within 5-10 working days."],["03","Receive Offer","Get credentials and loan offer via email."],["04","Choose Amount","Log in and select your preferred amount."],["05","Pay & Receive","Pay 15% fee via M-Pesa and get your loan in 24 hours."]];
  const programs = [
    ["Elderly Support Loans","KSh 15,000 - 50,000","For citizens aged 65 and above to support daily needs and medical expenses.","#0066cc"],
    ["Disability Support Loans","KSh 10,000 - 45,000","Financial support for persons with disabilities to improve quality of life.","#7c3aed"],
    ["Vulnerable Families","KSh 10,000 - 35,000","Emergency loans for vulnerable families facing financial hardship.","#10b981"],
  ];

  return (
    <div style={{ minHeight:"100vh", background:"white" }}>

      {/* Hero */}
      <div style={{ background:"linear-gradient(135deg,#0066cc 0%,#003d7a 100%)", padding:"80px 24px", textAlign:"center", color:"white", position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", top:-80, right:-80, width:300, height:300, borderRadius:"50%", background:"rgba(255,255,255,0.05)" }}/>
        <div style={{ position:"absolute", bottom:-60, left:-60, width:200, height:200, borderRadius:"50%", background:"rgba(255,255,255,0.05)" }}/>
        <div style={{ maxWidth:700, margin:"0 auto", position:"relative" }}>
          <div style={{ display:"inline-block", background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.25)", borderRadius:20, padding:"6px 18px", fontSize:12, fontWeight:700, letterSpacing:1, textTransform:"uppercase", marginBottom:24 }}>
            Official Imalisha Welfare Loan Programme
          </div>
          <h1 style={{ fontSize:46, fontWeight:900, margin:"0 0 20px", lineHeight:1.15, letterSpacing:"-1px" }}>
            Fast, Accessible Loans<br/>
            <span style={{ color:"#93c5fd" }}>For Those Who Need It Most</span>
          </h1>
          <p style={{ fontSize:18, opacity:.85, lineHeight:1.7, maxWidth:560, margin:"0 auto 36px" }}>
            Apply for a loan of up to <strong>KSh 50,000</strong>. Simple application, quick approval, disbursement within 24 hours of fee payment.
          </p>
          <div style={{ display:"flex", gap:14, justifyContent:"center", flexWrap:"wrap" }}>
            <button onClick={()=>setCurrentPage("apply")} style={{ background:"white", color:"#0066cc", border:"none", padding:"16px 36px", borderRadius:10, fontSize:16, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 20px rgba(0,0,0,0.2)" }}>
              Apply for a Loan
            </button>
            <button onClick={()=>setCurrentPage("eligibility")} style={{ background:"transparent", color:"white", border:"2px solid rgba(255,255,255,0.5)", padding:"16px 36px", borderRadius:10, fontSize:16, fontWeight:600, cursor:"pointer" }}>
              Check Eligibility
            </button>
          </div>
        </div>
      </div>

      {/* Stats */}
      <div style={{ background:"#1e3a5f", padding:"28px 24px" }}>
        <div style={{ maxWidth:1000, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(4,1fr)", gap:0 }}>
          {stats.map(([val,lbl],i)=>(
            <div key={lbl} style={{ textAlign:"center", padding:"16px 24px", borderRight:i<3?"1px solid rgba(255,255,255,0.1)":"none" }}>
              <div style={{ fontSize:28, fontWeight:900, color:"white", marginBottom:4 }}>{val}</div>
              <div style={{ fontSize:13, color:"rgba(255,255,255,0.6)", fontWeight:500 }}>{lbl}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Programmes */}
      <div style={{ padding:"72px 24px", background:"#f8fafc" }}>
        <div style={{ maxWidth:1000, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#0066cc", textTransform:"uppercase", letterSpacing:1.5, marginBottom:12 }}>Our Loan Products</div>
            <h2 style={{ fontSize:34, fontWeight:800, color:"#1e293b", margin:"0 0 14px", letterSpacing:"-0.5px" }}>Loan Programmes Available</h2>
            <p style={{ fontSize:16, color:"#6b7280", maxWidth:520, margin:"0 auto", lineHeight:1.7 }}>Tailored loans based on your category. Apply once and receive a personalised offer.</p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(280px,1fr))", gap:24 }}>
            {programs.map(([title,range,desc,color])=>(
              <div key={title} style={{ background:"white", borderRadius:14, padding:"28px 24px", boxShadow:"0 2px 12px rgba(0,0,0,0.07)", border:"1px solid #e2e8f0", transition:"all 0.2s" }}
                onMouseEnter={e=>{e.currentTarget.style.transform="translateY(-4px)";e.currentTarget.style.boxShadow="0 8px 24px rgba(0,0,0,0.12)";}}
                onMouseLeave={e=>{e.currentTarget.style.transform="translateY(0)";e.currentTarget.style.boxShadow="0 2px 12px rgba(0,0,0,0.07)";}}>
                <div style={{ width:48, height:48, background:color+"20", borderRadius:12, marginBottom:16, display:"flex", alignItems:"center", justifyContent:"center" }}>
                  <div style={{ width:24, height:24, background:color, borderRadius:6 }}/>
                </div>
                <h3 style={{ fontSize:17, fontWeight:700, color:"#1e293b", margin:"0 0 8px" }}>{title}</h3>
                <div style={{ fontSize:13, fontWeight:700, color:color, marginBottom:10, background:color+"15", display:"inline-block", padding:"3px 12px", borderRadius:20 }}>{range}</div>
                <p style={{ fontSize:14, color:"#6b7280", margin:"10px 0 20px", lineHeight:1.6 }}>{desc}</p>
                <button onClick={()=>setCurrentPage("apply")} style={{ width:"100%", padding:11, background:color, color:"white", border:"none", borderRadius:8, fontWeight:700, fontSize:14, cursor:"pointer" }}>Apply Now</button>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* How it works */}
      <div style={{ padding:"72px 24px", background:"white" }}>
        <div style={{ maxWidth:900, margin:"0 auto" }}>
          <div style={{ textAlign:"center", marginBottom:48 }}>
            <div style={{ fontSize:12, fontWeight:700, color:"#0066cc", textTransform:"uppercase", letterSpacing:1.5, marginBottom:12 }}>Simple Process</div>
            <h2 style={{ fontSize:34, fontWeight:800, color:"#1e293b", margin:"0 0 14px" }}>How It Works</h2>
            <p style={{ fontSize:16, color:"#6b7280", maxWidth:480, margin:"0 auto", lineHeight:1.7 }}>From application to disbursement in as little as 24 hours.</p>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(160px,1fr))", gap:20 }}>
            {steps.map(([num,title,desc])=>(
              <div key={num} style={{ textAlign:"center" }}>
                <div style={{ width:48, height:48, background:"linear-gradient(135deg,#0066cc,#0052a3)", borderRadius:"50%", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 14px", color:"white", fontWeight:900, fontSize:14, boxShadow:"0 4px 12px rgba(0,102,204,0.3)" }}>{num}</div>
                <h4 style={{ fontSize:14, fontWeight:700, color:"#1e293b", margin:"0 0 6px" }}>{title}</h4>
                <p style={{ fontSize:12, color:"#6b7280", margin:0, lineHeight:1.6 }}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Fraud Warning */}
      <div style={{ background:"#fff8e6", borderTop:"1px solid #f59e0b", borderBottom:"1px solid #f59e0b", padding:"20px 24px" }}>
        <div style={{ maxWidth:900, margin:"0 auto", display:"flex", gap:16, alignItems:"center", flexWrap:"wrap" }}>
          <div style={{ fontSize:28 }}></div>
          <div>
            <p style={{ margin:"0 0 4px", fontWeight:700, fontSize:14, color:"#92400e" }}>Fraud Alert � Protect Yourself</p>
            <p style={{ margin:0, fontSize:13, color:"#92400e", lineHeight:1.6 }}>
              We will NEVER ask for payment before approval. The only fee is the <strong>15% processing fee</strong> paid via M-Pesa after loan approval. Report fraud to <strong>Toll-Free 1533</strong>.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div style={{ background:"linear-gradient(135deg,#0066cc,#0052a3)", padding:"64px 24px", textAlign:"center", color:"white" }}>
        <h2 style={{ fontSize:32, fontWeight:800, margin:"0 0 14px", letterSpacing:"-0.5px" }}>Ready to Apply?</h2>
        <p style={{ fontSize:16, opacity:.85, margin:"0 0 32px", lineHeight:1.7 }}>No account needed. Apply in minutes and get a response within 5-10 working days.</p>
        <button onClick={()=>setCurrentPage("apply")} style={{ background:"white", color:"#0066cc", border:"none", padding:"16px 40px", borderRadius:10, fontSize:16, fontWeight:800, cursor:"pointer", boxShadow:"0 4px 20px rgba(0,0,0,0.2)" }}>
          Start Your Application
        </button>
      </div>

      {/* Footer */}
      <div style={{ background:"#1e293b", padding:"40px 24px" }}>
        <div style={{ maxWidth:1000, margin:"0 auto", display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))", gap:32, color:"rgba(255,255,255,0.6)" }}>
          <div>
            <p style={{ color:"white", fontWeight:700, fontSize:15, margin:"0 0 10px" }}>Imalisha Welfare Programme</p>
            <p style={{ fontSize:13, lineHeight:1.7, margin:0 }}>Providing accessible financial support to vulnerable members of society.</p>
          </div>
          <div>
            <p style={{ color:"white", fontWeight:700, fontSize:13, margin:"0 0 10px", textTransform:"uppercase", letterSpacing:.5 }}>Quick Links</p>
            {[["home","Home"],["about","About"],["eligibility","Eligibility"],["apply","Apply"],["contact","Contact"]].map(([id,lbl])=>(
              <p key={id} style={{ fontSize:13, margin:"0 0 6px", cursor:"pointer" }} onClick={()=>setCurrentPage(id)}>{lbl}</p>
            ))}
          </div>
          <div>
            <p style={{ color:"white", fontWeight:700, fontSize:13, margin:"0 0 10px", textTransform:"uppercase", letterSpacing:.5 }}>Contact Us</p>
            <p style={{ fontSize:13, margin:"0 0 6px" }}>Toll-Free: 1533</p>
            <p style={{ fontSize:13, margin:"0 0 6px" }}>support@socialwelfare.go.ke</p>
            <p style={{ fontSize:13, margin:0 }}>Mon - Fri: 8:00 AM - 5:00 PM</p>
          </div>
        </div>
        <div style={{ maxWidth:1000, margin:"32px auto 0", paddingTop:24, borderTop:"1px solid rgba(255,255,255,0.1)", textAlign:"center", fontSize:12, color:"rgba(255,255,255,0.4)" }}>
          2026 Imalisha Welfare Loan Programme. All rights reserved.
        </div>
      </div>
    </div>
  );
}



